import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { PackageResponseInterface } from '../../../../interfaces/package-response.interface';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';
import { firstValueFrom } from 'rxjs';
import { PresentationUtilsService } from '../../../services/presentation-utils.service';

@Component({
    selector: 'app-add-presentation',
    templateUrl: './add-presentation.component.html',
    styleUrls: ['./add-presentation.component.css'],
})
export class AddPresentationComponent {
    product: any;
    productId: string;
    quantity: number = null;
    selectedUnity = '';
    lastSelectedEmpaque: number = null;
    selectedEmpaque: number = null;
    optUnitsOfMeasurement: any[] = [];
    optPackaging: any[] = [];
    codeUnitMeasurement: string = null;

    private apiUrl: string = environment.apiSiriUrl;
    codigoSeleccionado: any;
    selectedTypeProduct: any;
    productTypeName: string;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private http: HttpClient,
        private presentationUtils: PresentationUtilsService
    ) {}

    ngOnInit() {
        this.route.paramMap.subscribe(async (params) => {
            this.productId = params.get('id-producto');
            const navigation = window.history.state;
            if (navigation.currentProduct) {
                this.product = navigation.currentProduct;
                console.log('this.product ', this.product);
                this.selectedTypeProduct = this.product.tipoProductoId;
                console.log(
                    'this.selectedTypeProduct ',
                    this.selectedTypeProduct
                );
            } else {
                await this.loadProduct();
            }
        });
        this.loadPackaging(this.selectedTypeProduct);
        this.loadUnitsOfMeasurement();
    }

    onChange(event: Event) {
        const target = event.target as HTMLSelectElement;
        const selectedIndex = target.selectedIndex;
        const selectedOption = target.options[selectedIndex];

        if (selectedOption instanceof HTMLOptionElement) {
            this.codigoSeleccionado =
                selectedOption.getAttribute('data-codigo');
        }
    }

    /**
     * Normaliza y redondea el valor de la propiedad `quantity` a un número específico de decimales.
     * Este método se asegura de que la cantidad tenga la precisión deseada (por defecto, un decimal),
     * evitando valores con más decimales de los permitidos.
     *
     * @param {number} [decimals=1] El número de decimales al que se redondeará la cantidad. El valor por defecto es 1.
     * @returns {void} Este método no retorna ningún valor; modifica directamente la propiedad `this.quantity`.
     */
    normalizeQuantity(decimals = 1): void {
        if (typeof this.quantity === 'number' && !Number.isNaN(this.quantity)) {
            this.quantity = Number(this.quantity.toFixed(decimals));
        }
    }

    limitQuantity() {
        if (this.quantity > 99999) {
            this.quantity = 99999;
        }
        if (this.quantity < 0) {
            this.quantity = 0;
        }
    }

    loadProduct() {
        this.http.get(`${this.apiUrl}producto/` + this.productId).subscribe(
            (response) => {
                this.product = response;
                console.log('this.product ', this.product);
                this.selectedTypeProduct = this.product.tipoProductoId;
                console.log(
                    'this.selectedTypeProduct /...',
                    this.selectedTypeProduct
                );
            },
            (error) => {
                console.error('Error al cargar presentacion', error);
            }
        );
    }

    verifyPresentationDuplicate(code: string) {
        const validateCodePresentation = this.product.presentaciones.find(
            (presentation) => presentation.codigoPresentacion === code
        );
        if (validateCodePresentation) {
            Swal.fire(
                'Esta presentación ya existe para este producto',
                '',
                'error'
            );
        }
        return validateCodePresentation;
    }
    async onSubmitAgregarPresentation() {
        const requiredFields = [
            { field: this.productId, message: 'ID de producto es requerido' },
            { field: this.selectedEmpaque, message: 'Empaque es requerido' },
            {
                field: this.selectedUnity?.trim(),
                message: 'Unidad de medida es requerida',
            },
            { field: this.quantity, message: 'Cantidad es requerida' },
        ];

        for (const { field, message } of requiredFields) {
            if (!field && field !== 0) {
                Swal.fire('Error', message, 'error');
                return;
            }
        }

        if (this.quantity <= 0) {
            Swal.fire('Error', 'La cantidad debe ser mayor a cero', 'error');
            return;
        }
        if (this.quantity > 99999) {
            Swal.fire(
                'Error',
                'La cantidad debe ser menor a 100000.0',
                'error'
            );
            return;
        }

        const selectedEmpaqueObj = this.optPackaging.find(
            (p: any) => p.id == this.selectedEmpaque
        );
        const empaqueCode = selectedEmpaqueObj ? selectedEmpaqueObj.codigo : '';

        this.codeUnitMeasurement =
            this.presentationUtils.calculatePresentationCode(
                empaqueCode,
                this.codigoSeleccionado,
                this.quantity
            );

        if (this.verifyPresentationDuplicate(this.codeUnitMeasurement)) {
            Swal.fire(
                'Error',
                'Esta presentación ya existe para el producto',
                'error'
            );
            return;
        }

        const formData = {
            empaqueUnidadMedidaId: this.selectedUnity,
            productoId: this.productId,
            cantidad: this.quantity,
            codigoPresentacion: this.codeUnitMeasurement,
        };

        try {
            const response = await firstValueFrom(
                this.http.post(`${this.apiUrl}presentacion`, formData)
            );

            await Swal.fire({
                title: '¡Éxito!',
                text: 'La presentación se ha creado correctamente',
                icon: 'success',
                confirmButtonText: 'Aceptar',
            });

            this.router.navigate([`${this.productId}/presentaciones`]);
        } catch (error) {
            console.error('Error al crear la presentación', error);

            let errorMessage = 'Ocurrió un error al crear la presentación';
            if (error.error?.message) {
                errorMessage += `: ${error.error.message}`;
            }

            Swal.fire('Error', errorMessage, 'error');
        }
    }

    onChangeEmpaque() {
        this.selectedUnity = '';
        this.quantity = null;
        this.codigoSeleccionado = '';
        this.loadUnitsOfMeasurement();
    }

    loadUnitsOfMeasurement() {
        if (this.selectedEmpaque !== this.lastSelectedEmpaque) {
            this.lastSelectedEmpaque = this.selectedEmpaque;
            this.http
                .get<
                    any[]
                >(`${this.apiUrl}unidad-medida/by-empaque/${this.selectedEmpaque}`)
                .subscribe(
                    (response) => {
                        this.optUnitsOfMeasurement = response;
                        this.codigoSeleccionado =
                            this.optUnitsOfMeasurement[0].codigo;
                    },
                    (error) => {
                        console.error(
                            'Error al cargar opciones de Dropdown 2',
                            error
                        );
                    }
                );
        }
    }

    loadPackaging(packageId) {
        if (packageId == '1') {
            this.productTypeName = 'plaguicida';
            this.loadPackage(this.productTypeName);
        } else if (packageId == '2') {
            this.productTypeName = 'fertilizante';
            this.loadPackage(this.productTypeName);
        } else if (packageId == '3') {
            this.productTypeName = 'coadyuvante';
            this.loadPackage(this.productTypeName);
        } else if (packageId == '4') {
            this.loadPackagingAll();
            this.selectedEmpaque = 5;
            this.quantity = 40;
            this.loadUnitsOfMeasurement();
            this.selectedUnity = '9';
        } else if (packageId == '5') {
            this.productTypeName = 'acondicionadorEnmienda';
            this.loadPackage(this.productTypeName);
        } else {
            this.selectedEmpaque = null;
            this.quantity = null;
            this.selectedUnity = '';
        }
    }

    loadPackagingAll() {
        this.http
            .get<PackageResponseInterface[]>(`${this.apiUrl}empaque`)
            .subscribe(
                (response) => {
                    this.optPackaging = response;
                },
                (error) => {
                    console.error(
                        'Error al cargar opciones de Dropdown 2',
                        error
                    );
                }
            );
    }

    loadPackage(productTypeName) {
        this.http
            .get<
                PackageResponseInterface[]
            >(`${this.apiUrl}empaque/${productTypeName}`)
            .subscribe(
                (response) => {
                    this.optPackaging = response;
                },
                (error) => {
                    console.error(
                        'Error al cargar opciones de Dropdown 2',
                        error
                    );
                }
            );
    }

    padWithZeros(input: number): string {
        const targetLength = 5;
        const diff = targetLength - input.toString().length;
        if (diff > 0) {
            return '0'.repeat(diff) + input;
        }
        return input.toString();
    }
}
